import { lazy } from 'react';
import { IRouteProps } from 'src/modules';

export const route = '/project/edit/:id';

const CreateCollectionsRoute: IRouteProps = {
    path: route,
    exact: true,
    component: lazy(() => import('src/modules/CreateCollections/EditCollections')),
    name: 'CreateCollections',
};

export default CreateCollectionsRoute;
